import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foepostingsApi = api
  .enhanceEndpoints({ addTagTypes: ['FOEPostings'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOEPostingss: builder.query<
        (fo_echeckin & fo_epostings & fo_mroommaster & fo_eaddrbook)[],
        string
      >({
        query: cid => `foepostings/${cid}`,
        providesTags: ['FOEPostings']
      }),
      getFOEPostingsById: builder.query<fo_epostings, string>({
        query: id => `foepostings/byid/${id}`,
        providesTags: ['FOEPostings']
      }),
      getFOEPostingsByRoom: builder.query<(fo_epostings & fo_mhead)[], any>({
        query: rooms => `foepostings/byrooms/${rooms.toString()}`,
        providesTags: ['FOEPostings']
      }),
      insertFOEPostings: builder.mutation({
        query: foepostings => ({
          url: `foepostings/`,
          method: 'POST',
          body: foepostings
        }),
        invalidatesTags: ['FOEPostings']
      }),
      updateFOEPostings: builder.mutation({
        query: foepostings => ({
          url: `foepostings/`,
          method: 'PUT',
          body: foepostings
        }),
        invalidatesTags: ['FOEPostings']
      }),
      deleteFOEPostings: builder.mutation({
        query: foepostings => ({
          url: `foepostings/${foepostings.ps_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOEPostings']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOEPostingssQuery,
  useGetFOEPostingsByIdQuery,
  useGetFOEPostingsByRoomQuery,
  useInsertFOEPostingsMutation,
  useUpdateFOEPostingsMutation,
  useDeleteFOEPostingsMutation
} = foepostingsApi;

